// ANNI — "Complete the Set"-Fallback.
// Kein matching_product-Metafeld gesetzt → Complementary-Empfehlungen
// über das Section-Rendering der Product-Recommendations-API laden
// und die eigene Sektion mit dem gerenderten HTML ersetzen.
// Keine Empfehlung verfügbar → Sektion bleibt versteckt (kein Leerraum).
class AnniCompleteTheSet extends HTMLElement {
  async connectedCallback() {
    const { recommendationsUrl, sectionId, productId } = this.dataset;
    if (!recommendationsUrl || !sectionId || !productId) return;

    const url = `${recommendationsUrl}?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&intent=complementary&limit=1`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();

      const fragment = new DOMParser().parseFromString(html, 'text/html');
      const fresh = fragment.querySelector('anni-complete-the-set');
      const freshSection = fragment.querySelector('.anni-set');
      const ownSection = this.closest('.anni-set');

      // Empfehlung vorhanden → Inhalt übernehmen und Sektion zeigen
      if (fresh && freshSection && !freshSection.hasAttribute('hidden') && ownSection) {
        this.replaceChildren(...fresh.childNodes);
        ownSection.removeAttribute('hidden');
      } else {
        ownSection?.setAttribute('hidden', '');
      }
    } catch {
      // Netzwerk-/API-Fehler: Sektion still verstecken
      this.closest('.anni-set')?.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('anni-complete-the-set')) {
  customElements.define('anni-complete-the-set', AnniCompleteTheSet);
}
